import { PropsWithChildren } from 'react';

import { ClaimContext } from './claim-context';
import { useClaimProvider } from './useClaimProvider';

export default function ClaimProvider(props: PropsWithChildren) {
  const values = useClaimProvider();
  return <ClaimContext.Provider value={values}>{props.children}</ClaimContext.Provider>;
}
